// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"c4d65cec","124":"a3f705b5","193":"72a27cf5","216":"5d46bf8c","475":"dcf7bb1a","533":"1726290a","669":"474b7d8b","773":"6a3c68c3","925":"4f2fe926","986":"1bb62644"}[chunkId] + ".chunk.js";
};